module.exports = __webpack_public_path__ + "static/media/facebook-pink-on-white.8fbf59f7.svg";